import type { StandaloneComponent, StandaloneComponentProps } from '@/types/component';
import type { ReactNode } from 'react';
import { Loader, type LoaderComponentProps } from './Loader';

export interface StandaloneLoaderProps extends StandaloneComponentProps {
  content?: ReactNode;
  options?: LoaderComponentProps;
}

export const StandaloneLoader: StandaloneComponent<StandaloneLoaderProps> = ({ content, options, ...props }) => {
  return (
    <Loader {...options} {...props}>
      {content}
    </Loader>
  );
};

export default StandaloneLoader;
